import { __read } from 'tslib';
import React from 'react';
import { useStateRef, useOnMount } from '@baidu/bce-hooks';
import { UModalMask } from '../UModalMask/index.js';

/**
 * 登录弹窗
 * @param {object} props
 * @param {boolean} props.maskClosable mask是否可点
 * @param {boolean} props.hideCloseIcon 是否显示
 * @param {boolean} props.needQualify 是否需要实名认证
 * @param {function} props.onOk 登录成功
 * @param {function} props.onCancel 登录失败
 * @returns TSX.Element
 */
var ULoginModal = function ULoginModal(props) {
  var _a = __read(useStateRef(true), 2),
    show = _a[0],
    setShow = _a[1];
  var cancelHandler = function cancelHandler() {
    setShow(false);
    props.onCancel && props.onCancel();
  };
  var close = function close() {
    setShow(false);
  };
  useOnMount(function () {
    var regSuccess = false;
    var handleMessage = function handleMessage(e) {
      var _a, _b, _c, _d;
      if ((_a = e.data) === null || _a === void 0 ? void 0 : _a.loginSuccess) {
        close();
        props.onOk && props.onOk({
          regSuccess: regSuccess
        });
      }
      if ((_b = e.data) === null || _b === void 0 ? void 0 : _b.activateSuccess) {
        close();
        props.onOk && props.onOk({
          activateSuccess: true
        });
      }
      if ((_c = e.data) === null || _c === void 0 ? void 0 : _c.qualifySuccess) {
        close();
        props.onOk && props.onOk({
          qualifySuccess: true
        });
      }
      if ((_d = e.data) === null || _d === void 0 ? void 0 : _d.regSuccess) {
        regSuccess = true;
      }
    };
    window.addEventListener('message', handleMessage, false);
    return function () {
      window.removeEventListener('message', handleMessage);
    };
  });
  return /*#__PURE__*/React.createElement(UModalMask, {
    show: show,
    maskClosable: props.maskClosable,
    onClose: cancelHandler
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("iframe", {
    className: "portal-login-iframe",
    width: "600",
    height: "600",
    src: props.href
  }), !props.hideCloseIcon && (/*#__PURE__*/React.createElement("div", {
    className: "portal-login-iframe-close-icon",
    onClick: function onClick() {
      return setShow(false);
    }
  }))));
};

export { ULoginModal };
